export const COMPANY_NAME = 'Cheuk Lee';
export const SLOGAN = 'Front-end developer for your team';